/* eslint-disable react/react-in-jsx-scope */
import { ReactElement } from 'react'
import { isString } from 'lodash'
import {
  StyledIcons,
  StyledIcon,
  StyledCard,
  StyledLink,
} from './styled-components'
import Icon from '../../icon'
import { Category, Training, Part, Question } from '../../../types/training'
import Text from '../../text'

interface CardProps {
  element: Training | Category | Part | Question | string
  link?: string
  onClickEdit: (element: Training | Category | Part | Question | string) => void
  onDeleteClick?: (
    element: Training | Category | Part | Question | string
  ) => void
}
const Card = ({
  element,
  onClickEdit,
  link,
  onDeleteClick,
}: CardProps): ReactElement => {
  function isQuestion(
    object: Training | Category | Part | Question | string
  ): object is Question {
    if (!isString(object)) {
      return 'answers' in object
    }
    return false
  }
  function isPart(
    object: Training | Category | Part | Question | string
  ): object is Part {
    if (!isString(object)) {
      return 'quizType' in object
    }
    return false
  }
  function isCategory(
    object: Training | Category | Part | Question | string
  ): object is Category {
    if (!isString(object)) {
      return 'parts' in object
    }
    return false
  }

  function isTraining(
    object: Training | Category | Part | Question | string
  ): object is Training {
    if (!isString(object)) {
      return 'isVisible' in object
    }
    return false
  }
  return (
    <>
      <StyledCard>
        <StyledLink href={link || undefined}>
          {isCategory(element) || isPart(element) ? (
            <Text> {element.placement} -</Text>
          ) : null}
          {isPart(element) && element.isWhat === 'quiz' ? (
            <Icon name="bi:question-square" width={25} height={25} />
          ) : null}
          <Text>
            {isQuestion(element)
              ? element.text
              : isString(element)
              ? element
              : element.title}
          </Text>
        </StyledLink>
        <StyledIcons>
          {isTraining(element) && (
            <Icon
              name={element.isVisible ? 'bx:show-alt' : 'bx:hide'}
              width={25}
              height={25}
            />
          )}
          <StyledIcon onClick={() => onClickEdit(element)}>
            <Icon name="clarity:note-edit-line" width={25} height={25} />
          </StyledIcon>
          <StyledIcon
            onClick={() => (onDeleteClick ? onDeleteClick(element) : null)}
          >
            <Icon name="fluent:delete-20-regular" width={25} height={25} />
          </StyledIcon>
        </StyledIcons>
      </StyledCard>
    </>
  )
}

export default Card
